import {
  AnchorButton,
  Button,
  Card,
  Collapse,
  ControlGroup,
  EditableText,
  Elevation,
  Icon,
  InputGroup,
  NonIdealState,
  NumericInput,
  Spinner,
  Tag,
  Dialog,
  Classes,
  TextArea,
} from "@blueprintjs/core";
import React from "react";
import {
  apiCallPost,
  calculateRatesPaise,
  indianRupee,
  niceDate,
} from "../fns/util";
import { inject, observer } from "mobx-react";
import cogoToast from "cogo-toast";
import _ from "lodash";
import ReactList from "react-list";
import MasterEntity from "../v2/MasterEntity";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import MasterRow from "../v2/MasterRow";
import { withRouter } from "react-router";
import ColumnDefs from "../v2/ColumnDefs";
import LedgerCreator from "../v2/LedgerCreator";
import LedgerSearchTopBar from "../v2/LedgerSearchTopBar";
import SxReportTopBar from "../v2/SxReportTopBar";
import SxSearch from "../v2/SxSearch";
import SingleIDSelectWrapper from "../utils/SingleIDSelectWrapper";
import { DateRangeInput } from "@blueprintjs/datetime";
import moment from "moment";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import MultiSelectWrapper from "../utils/MultiSelectWrapper";
import { nanoid } from "nanoid";
import ReactQuill from "react-quill";
class DischargeTemplatesCRUD extends React.Component {
  state = {
    isLoading: false,
    changed: false,
    loadedTemplateNames: [],
    uiSelectedTemplate: null,
    loadedTemplate: null,
  };
  async componentDidMount() {
    await this.doLoadTemplateNames();
  }

  doLoadTemplateNames = async () => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/sxDischargeTemplateMaster/getAll/skeleton`
      );
      this.setState({ loadedTemplateNames: res, isLoading: false });
    } catch (err) {}
  };
  doLoadTemplate = async (_id) => {
    try {
      this.setState({ isLoading: true });
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/sxDischargeTemplateMaster/getById`,
        { _id: _id }
      );
      this.setState({ loadedTemplate: res, isLoading: false });
    } catch (err) {}
  };
  doSaveTemplate = async (_id, entityName, content) => {
    try {
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/sxDischargeTemplateMaster/update`,
        { _id: _id, doc: { content: content, entityName } }
      );
      this.setState({ loadedTemplate: res });
    } catch (err) {}
  };
  doCreateTemplate = async (entityName) => {
    try {
      let res = await apiCallPost(
        `/meta-sx/${this.props.authStore.prefix}/sxDischargeTemplateMaster/createNew`,
        { entityName }
      );
      this.setState({
        loadedTemplateNames: [...this.state.loadedTemplateNames, res],
        isLoading: false,
        uiSelectedTemplate: res,
        loadedTemplate: res,
      });
    } catch (err) {}
  };
  doDeleteTemplate = async (_id) => {};

  renderSearchHeader = () => {
    return (
      <Card className="dark__bg" elevation={Elevation.FOUR}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <ControlGroup>
            <Tag large minimal>
              Select a Template
            </Tag>
            <SingleIDSelectWrapper
              showSelectProp={true}
              width="300px"
              items={this.state.loadedTemplateNames.map((each) => {
                return {
                  ...each,
                  searchName: each.entityName,
                };
              })}
              selectedItem={this.state.uiSelectedTemplate}
              labelKey="searchName"
              onChange={(item) => {
                this.setState(
                  { uiSelectedTemplate: item, isLoading: true },
                  async () => {
                    await this.doLoadTemplate(item._id);
                  }
                );
              }}
            />
          </ControlGroup>
          <ControlGroup>
            <Button
              icon="add"
              intent="success"
              text="Create New Template"
              onClick={() => {
                this.setState(
                  {
                    uiSelectedTemplate: null,
                    isLoading: true,
                  },
                  async () => {
                    await this.doCreateTemplate("<New Template>");
                    this.setState({ isLoading: false });
                  }
                );
              }}
            />
          </ControlGroup>
        </div>
      </Card>
    );
  };

  renderEditArea = () => {
    if (this.state.isLoading || this.state.loadedTemplate === null) {
      return (
        <div className="padding__20">
          <NonIdealState
            icon={<Spinner />}
            title="Fetching..."
            description="Loading discharge templates content..."
          />
        </div>
      );
    }

    return (
      <Card className="dark__bg" elevation={Elevation.FOUR}>
        <div>
          <ControlGroup style={{ margin: "10px" }}>
            <Tag large minimal>
              Edit Template Name
            </Tag>
            <InputGroup
              fill
              leftIcon="edit"
              width={"500px"}
              disabled={this.state.isLoading}
              value={this.state.loadedTemplate.entityName}
              onChange={(event) => {
                this.setState(
                  {
                    loadedTemplate: {
                      ...this.state.loadedTemplate,
                      entityName: event.target.value,
                    },
                  },
                  () => this.setState({ changed: true })
                );
              }}
            />
          </ControlGroup>
          <ReactQuill
            preserveWhitespace={true}
            theme="snow"
            value={this.state.loadedTemplate.content}
            onChange={(val) => {
              this.setState({
                loadedTemplate: {
                  ...this.state.loadedTemplate,
                  content: val,
                },
                changed: true,
              });
            }}
            modules={{
              clipboard: {
                matchVisual: false,
              },
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [
                  { list: "ordered" },
                  { list: "bullet" },
                  { indent: "-1" },
                  { indent: "+1" },
                ],
                ["link", "image"],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "blockquote",
              "list",
              "bullet",
              "indent",
              "link",
              "image",
            ]}
          />
          <ControlGroup
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              loading={this.state.isLoading}
              disabled={this.state.isLoading || this.state.changed === false}
              intent="success"
              text="Save Changes"
              icon="endorsed"
              onClick={() => {
                this.setState({ isLoading: true }, async () => {
                  await this.doSaveTemplate(
                    this.state.loadedTemplate._id,
                    this.state.loadedTemplate.entityName,
                    this.state.loadedTemplate.content
                  );
                  this.setState({ isLoading: false, changed: false });
                });
              }}
            />
          </ControlGroup>
        </div>
      </Card>
    );
  };

  render() {
    return (
      <div className="padding__20">
        {this.renderSearchHeader()}
        {this.renderEditArea()}
      </div>
    );
  }
}

export default inject("authStore")(
  observer(withRouter(DischargeTemplatesCRUD))
);
